module.exports = __webpack_public_path__ + "static/media/Pool2.36ce69ea.jpg";